import { render, staticRenderFns } from "./DefInput.vue?vue&type=template&id=54efc1df&scoped=true&"
import script from "./DefInput.vue?vue&type=script&lang=js&"
export * from "./DefInput.vue?vue&type=script&lang=js&"
import style0 from "./DefInput.vue?vue&type=style&index=0&id=54efc1df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54efc1df",
  null
  
)

export default component.exports